import { Tape } from "../atoms/Tape.tsx";
import { PORTRAIT_PLACEHOLDER } from "../../lib/fallback.ts";

const DEFAULT_PORTRAIT = "/portrait.webp";

/** Renders the responsive optimized portrait when settings use the default asset. */
function PortraitPicture() {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet="/portrait.webp 1x, /portrait@2x.webp 2x"
      />
      <img
        width={400}
        height={440}
        alt="Illustrated portrait of Akhshy Ganesh"
        src="/portrait.jpg"
        loading="eager"
        decoding="async"
      />
    </picture>
  );
}

export function Polaroid({ src, caption }: { src: string; caption: string }) {
  const isDefault = src === DEFAULT_PORTRAIT;

  return (
    <figure className="polaroid">
      <Tape />
      {isDefault ? (
        <PortraitPicture />
      ) : (
        <img
          width={400}
          height={440}
          alt="Illustrated portrait of Akhshy Ganesh"
          src={src || PORTRAIT_PLACEHOLDER}
          loading="eager"
          decoding="async"
        />
      )}
      <figcaption className="polaroid-caption">{caption}</figcaption>
    </figure>
  );
}
